import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Converts UTC time string to local time string based on user's system timezone.
 * @param utcTime - UTC datetime string (e.g. "2025-11-11T09:00:00Z") or Date
 * @param format - Desired output format (default: "YYYY-MM-DD HH:mm:ss")
 * @returns Local time formatted string
 */
export const convertUTCToLocal = (
  utcTime: string | Date | undefined,
  format: string = "DD-MMM-YYYY HH:mm"
): string => {
  if (!utcTime) return "";
  return dayjs.utc(utcTime).local().format(format);
};

/**
 * Converts local time to UTC string (for sending to backend).
 * @param localTime - Local datetime string or Date object
 * @returns UTC time in ISO format (e.g. "2025-11-11T09:00:00Z")
 */
export const convertLocalToUTC = (localTime: string | Date | Dayjs): string => {
  if (!localTime) return "";
  return dayjs(localTime).utc().toISOString();
};

/**
 * Get current UTC timestamp (useful for logging or backend sync)
 * @returns Current UTC ISO string
 */
export const getCurrentUTCTime = (): string => {
  return dayjs.utc().toISOString();
};

/**
 * Get user's system timezone name
 * @returns Timezone name (e.g. "Asia/Kolkata")
 */
export const getUserTimeZone = (): string => {
  return dayjs.tz.guess();
};
